import { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import "./HomeFAQ.css";

const faqs = [
  {
    q: "How much does website and software development cost?",
    a: "The cost depends on project scope, features, and technology stack. At Oglitz Software, pricing typically starts from basic websites to enterprise-grade software solutions tailored to business needs.",
  },
  {
    q: "Do you work with international clients?",
    a: "Yes. We work with clients across India, Dubai (UAE), Europe, the USA, and global markets, delivering scalable digital products remotely.",
  },
  {
    q: "What technologies do you use for development?",
    a: "We use modern technologies such as React, Next.js, Node.js, Laravel, React Native, AWS, MongoDB, MySQL, and cloud-native architectures.",
  },
  {
    q: "Do you provide ongoing support and maintenance?",
    a: "Absolutely. We offer long-term maintenance, performance optimization, security updates, and feature enhancements after project delivery.",
  },
];

const HomeFAQ = () => {
  const [open, setOpen] = useState(null);

  return (
    <section
      className="oglitz-home-faq"
      aria-labelledby="oglitz-home-faq-title"
    >
      <div className="oglitz-home-faq__inner">
        <h2 id="oglitz-home-faq-title">
          Frequently Asked <span>Questions</span>
        </h2>

        <div className="oglitz-home-faq__list">
          {faqs.map((item, i) => (
            <article
              key={i}
              className={`oglitz-home-faq__item ${open === i ? "active" : ""}`}
            >
              <button
                className="oglitz-home-faq__question"
                onClick={() => setOpen(open === i ? null : i)}
                aria-expanded={open === i}
              >
                {item.q}
                <FaChevronDown />
              </button>

              <div className="oglitz-home-faq__answer">
                <p>{item.a}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeFAQ;
